import { Button, Card, Icon, Meter, Pill, Stack, Text } from '@/design-system'
import { BentoGrid, BentoSpan } from '@/components/Bento'
import { StatTile } from '@/components/StatTile'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'
import { VAULTS } from './invest-data'
import { formatPercent } from '@/lib/money'


export function InvestScreen() {
  return (
    <>
      <PageHeader
        title="Invest"
        subtitle="Three ways to put idle balance to work, ordered by how much you can lose."
        actions={<Button variant="primary" size="md" iconStart="add" to="/invest/vault/open">Open a Vault</Button>}
      />

      <BentoGrid>
        {[
          { label: 'Invested', value: '$6,400.00', note: 'Across 2 products' },
          { label: 'Earned this year', value: '$214.86', tone: 'positive' as const, note: 'Paid monthly' },
          { label: 'Vault rate today', value: '2.05%', note: 'Moves with SOFR' },
          { label: 'Idle balance', value: '$11,840.50', note: 'Earning nothing' },
        ].map((stat) => (
          <StatTile key={stat.label} stat={stat} />
        ))}

        {VAULTS.map((vault) => (
          <BentoSpan key={vault.id} span={2}>
            <Card tone="light">
              <Card.Header>
                <Text variant="subtitle" weight="bold">{vault.name}</Text>
                <Pill tone="accent">{formatPercent(vault.apy)}</Pill>
              </Card.Header>
              <Text variant="caption" tone="secondary" className="pb-mt-3">{vault.summary}</Text>
              <Stack gap={2} className="pb-mt-5">
                <Stack direction="row" justify="between" align="center">
                  <Text variant="eyebrow" tone="secondary">Risk</Text>
                  <Text variant="eyebrow" weight="semibold" numeric>{vault.rateBasis}</Text>
                </Stack>
                <Meter value={vault.risk} height={6} tone="ink" label={`${vault.name} risk`} />
              </Stack>
              <Card.Footer>
                <Button variant="outline" size="sm" block iconEnd="arrow_forward" to={`/invest/${vault.id}`}>See details</Button>
              </Card.Footer>
            </Card>
          </BentoSpan>
        ))}

        <BentoSpan span={2}>
          <Card tone="dark">
            <Text variant="caption" weight="semibold" tone="onDark">How the rate is set</Text>
            <Text variant="caption" tone="onDarkMuted" className="pb-mt-3">
              We never promise a fixed APY. What you earn is defined as the index minus a spread, so
              the rate you see moves with the market rather than against it.
            </Text>
            <Stack gap={0} className="pb-mt-4">
              {[['Index today · SOFR', '3.85%'], ['Our spread', '1.80 pts'], ['You earn', '2.05%']].map(([label, value], index) => (
                <div key={label} className={checkout.line}>
                  <Text variant="caption" tone="onDarkMuted">{label}</Text>
                  <Text variant="caption" weight="semibold" tone={index === 2 ? 'accent' : 'onDark'} numeric>{value}</Text>
                </div>
              ))}
            </Stack>
            <Stack direction="row" align="center" gap={3} className="pb-mt-4">
              <Icon name="trending_up" size={18} />
              <Text variant="eyebrow" tone="onDarkMuted">
                When rates rise you earn more, automatically. Nothing to switch.
              </Text>
            </Stack>
          </Card>
        </BentoSpan>
      </BentoGrid>
    </>
  )
}
